import HelpIcon from "@mui/icons-material/Help";
import {
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    Switch,
    Tooltip,
} from "@mui/material";

const ExcludedWords = ({ itemsState, handleChange, disabledMode }) => {
    return (
        <FormControl component="fieldset" variant="standard" disabled={disabledMode}>
            <FormLabel component="legend">
                Excluir:{" "}
                <Tooltip
                    title={
                        "Las categorías de exclusión consideran el idioma castellano, en caso de textos en otro idioma carece de sentido gramatical."
                    }
                >
                    <HelpIcon></HelpIcon>
                </Tooltip>
            </FormLabel>
            <FormGroup>
                <Grid container sx={{ width: "100%" }}>
                    {itemsState.map((item) => (
                        <Grid key={item.name} item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={item.checked}
                                        onChange={(evt) => handleChange(evt, item)}
                                        name={item.name}
                                    />
                                }
                                label={item.name}
                            />
                        </Grid>
                    ))}
                </Grid>
            </FormGroup>
        </FormControl>
    );
};

export default ExcludedWords;
